/* eslint-disable react/no-direct-mutation-state */
import { Button, Form, Popup, TextArea, TextBox } from 'devextreme-react';
import { SelectBox, Item as SbItem } from 'devextreme-react/select-box';
import { ButtonItem, ButtonOptions, EmptyItem, Label, SimpleItem } from 'devextreme-react/form';
import { Item, Menu, Item as MenuItem } from 'devextreme-react/menu';
import { Component } from 'react';
import Inline from '../Inline';
import { apiGetP, apiPostP } from '../../GanjiTools';
import { RadioGroup, Item as RadioItem } from 'devextreme-react/radio-group';
import { DropDownButton, Item as DdbItem } from 'devextreme-react/drop-down-button';
import MinimalButton from '../MinimalButton';
import FontAwesomeIcon from '../utils/FontAwesomeIcon';
import WtMenu from '../wt/WtMenu';
import './MenuBuilder.css';
import { GroupItem } from 'devextreme-react/data-grid';


class MenuBuilder extends Component {
    constructor(props) {
        super(props);

        this.onEditItem = this.onEditItem.bind(this);
        this.onClickOnItem = this.onClickOnItem.bind(this);
        MenuBuilder.doOnAllItems = MenuBuilder.doOnAllItems.bind(this);
        this.onLoadMenu = this.onLoadMenu.bind(this);
        this.onBuildNewMenu = this.onBuildNewMenu.bind(this);
    }

    addNewItem = {
        text: '(گزینه جدید)',
        icon: 'plus',
        parentIid: null,
        iid: -1,
        sid: 'addnew',
        onClick: () => this.onClickOnItem('addnew', null),
    };

    state = {
        parentIid: 0,
        items: [],
        viewMode: 'design',
        _item: {
            iid: null, parentIid: null, order: 0, accessConditions: [], badgeAction: '',
            text: '', icon: '', targetType: 'sub', table: '', component: '', props: '', script: ''
        },
        itemsKey: 1,
        namesKey: 1,
    }

    static iidCounter = 1;

    onClickOnItem(sid, iid) {
        switch (sid) {
            case 'addnew':
                this.setState({ itemPopVisible: true, parentIid: null, _item: { iid: null, parentIid: null, icon: '' } });
                return;
            case 'addsub':
                this.setState({ itemPopVisible: true, _item: { iid: null, parentIid: iid } });
                return;
            case 'edit':
                this.onEditItem(iid);
                return;
            case 'delete':
                this.onDelete(iid);
                return;
        }

        console.log('could not find sid=', sid, ', iid=', iid);
    }

    static doOnAllItems = (items, task) => {
        if (!(items?.length > 0))
            return;

        for (let mi of items) {
            task(mi);
            MenuBuilder.doOnAllItems(mi.items, task);
        }
    }

    static filterItems = (items, condition) => {
        let res = [];

        if (!(items?.length > 0))
            return res;

        for (let item of items) {
            if (!condition(item))
                continue;

            let itm = { ...item, items: null };
            res.push(itm);
            let subs = MenuBuilder.filterItems(item.items, condition);
            itm.items = subs?.length > 0 ? subs : null;
        }
        return res;
    }

    static findBiggestIid = items => {
        if (!(items?.length > 0))
            return 0;

        let max = 0;

        for (let mi of items) {
            if (mi.iid > max)
                max = mi.iid;

            let b = MenuBuilder.findBiggestIid(mi.items);

            if (b > max)
                max = b;
        }
        return max;
    }


    static findMenuItem = (iid, items) => {
        if (!(items?.length > 0))
            return null;

        for (let mi of items) {
            if (mi.iid === iid)
                return mi;

            let f = MenuBuilder.findMenuItem(iid, mi.items);

            if (f)
                return f;
        }
        return null;
    }

    getCurrItem = () => {
        return this.state._item?.iid > 0 ? MenuBuilder.findMenuItem(this.state._item.iid, this.state.items) : null;
    }

    setViewMode = viewMode => {
        if (viewMode === 'preview' && !(this.state.name?.length > 0))
            this.setState({ saveMenuPopVisible: true });
        else
            this.setState({ viewMode });
    }

    designItems = iid => {
        let addSubItem = {
            text: '(افزودن زیر منو)',
            icon: 'chevronleft',
            parentIid: iid,
            iid: -3 * iid - 1,
            sid: 'addsub',
            items: [],
            visible: this.state._item.targetType === 'sub',
            onClick: () => this.onClickOnItem('addsub', iid),
        };

        let cmdSubItem = {
            text: '(ویرایش)',
            icon: 'edit',
            parentIid: iid,
            iid: -3 * iid - 2,
            sid: 'edit',
            items: [],
            onClick: () => this.onClickOnItem('edit', iid),
        };

        let delSubItem = {
            text: '(حذف)',
            icon: 'trash',
            parentIid: iid,
            iid: -3 * iid - 3,
            sid: 'delete',
            onClick: () => this.onClickOnItem('delete', iid),
            items: [],
        };

        return [addSubItem, cmdSubItem, delSubItem];
    }

    onSaveItem = thenSaveMenu => {
        let isNew = !(this.state._item.iid > 0);
        let currItem = this.getCurrItem();

        if (!isNew) {
            Object.assign(currItem, this.state._item);

            let addsub = currItem.items.find(x => x.sid === 'addsub');

            if (addsub)
                addsub.visible = currItem.targetType === 'sub';
        }
        else {
            this.state._item.iid = ++MenuBuilder.iidCounter;

            let iid = this.state._item.iid;

            // let addSubItem = {
            //     text: '(افزودن زیر منو)',
            //     icon: 'chevronleft',
            //     parentIid: iid,
            //     iid: -3 * iid - 1,
            //     sid: 'addsub',
            //     items: [],
            //     visible: this.state._item.targetType === 'sub',
            //     onClick: () => this.onClickOnItem('addsub', iid),
            // };

            // let cmdSubItem = {
            //     text: '(ویرایش)',
            //     icon: 'edit',
            //     parentIid: iid,
            //     iid: -3 * iid - 2,
            //     sid: 'edit',
            //     items: [],
            //     onClick: () => this.onClickOnItem('edit', iid),
            // };

            // let delSubItem = {
            //     text: '(حذف)',
            //     icon: 'trash',
            //     parentIid: iid,
            //     iid: -3 * iid - 3,
            //     sid: 'delete',
            //     onClick: () => this.onClickOnItem('delete', iid),
            //     items: [],
            // }

            this.state._item.items = this.designItems(iid); // [addSubItem, cmdSubItem, delSubItem];

            let parent = this.state._item.parentIid > 0 ? MenuBuilder.findMenuItem(this.state._item.parentIid, this.state.items) : null;

            if (!parent)
                this.state.items.push(this.state._item);
            else
                parent.items.push(this.state._item);

            if (thenSaveMenu && this.state.name?.length > 0)
                this.onSaveMenu();
        }

        this.setState({ itemsKey: this.state.itemsKey + 1 });
    }

    onEditItem(iid) {
        let currItem = iid > 0 ? MenuBuilder.findMenuItem(iid, this.state.items) : null;

        if (!currItem) {
            window.notif('آیتم نامشخص');
            return;
        }

        this.setState({ _item: currItem, itemPopVisible: true });
    }

    onLoadMenusList = () => {
        apiGetP('/api/menu/names').catch(window.notif)
            .then(res => {
                let { error, list } = res ?? { error: 'No result.' };
                if (error?.length > 0) {
                    window.notif(error);
                    return;
                }
                this.setState({ namesKey: this.state.namesKey + 1, names: list });
            });
    }

    onLoadMenu(name) {
        apiGetP(`/api/menu/load?name=${name}`)
            .catch(window.notif)
            .then(res => {
                res ??= { error: 'No response' };

                if (res.error?.length > 0) {
                    window.notif(res.error);
                    return;
                }

                let { name, items } = res;
                items ??= [];

                if (!items.find(x => x.sid === 'addnew'))
                    items = [this.addNewItem, ...items];

                this.state.items = items;

                MenuBuilder.doOnAllItems(this.state.items, item => {
                    if (item.iid < 0) {
                        //let sid = item.sid, iid = item.parentIid;
                        item.onClick = () => this.onClickOnItem(item.sid, item.parentIid);
                    }
                    else {
                        item.items ??= [];
                        let des = this.designItems(item.iid);

                        des.forEach(di => {
                            if (!item.items.find(i => i.iid < 0 && i.sid === di.seed))
                                item.items.push(di);
                        });
                    }
                });

                MenuBuilder.iidCounter = 1 + MenuBuilder.findBiggestIid(this.state.items);
                this.setState({ name, itemsKey: this.state.itemsKey + 1 });
            });
    }

    onSaveMenu = () => {
        apiPostP('/api/menu/save', {
            name: this.state.name,
            items: MenuBuilder.filterItems(this.state.items, i => i.iid > 0) // this.state.items
        }).catch(window.notif)
            .then(res => {
                let { error } = res ?? { error: 'No result.' };
                if (error?.length > 0)
                    window.notif(error);
            });
    }

    onBuildNewMenu = thenForceUpdate => {
        this.state.items = [this.addNewItem];

        this.state.name = '';
        this.state.viewMode = 'design';

        if (thenForceUpdate)
            this.forceUpdate();
    }

    getRealItems = () => {
        return MenuBuilder.filterItems(this.state.items, i => i.iid > 0);
    }

    componentDidMount() {
        apiGetP(`/api/dyna/dbdata?includeColumns=n&forceLoadTablesList=y`).catch(window.notif)
            .then(res => {
                let { tableProps } = res ?? { tableProps: [], parentColName: '', groupColName: '', schemas: [] };
                let tables = tableProps.filter(x => x.schema !== 'Uni');
                //this.setState({ tables });
                this.state.tables = tables;
                this.onBuildNewMenu(false);
                this.onLoadMenusList();
            });
    }

    render() {
        this.state._item.targetType ??= 'sub';
        let items = this.state.viewMode === 'preview' ? this.getRealItems() : this.state.items;

        if (!(items?.length > 0))
            items = [{ text: 'گزینه ای وجود ندارد', icon: 'warning', disabled: true }];

        let itm = this.state._item;

        let targetDetailsLookup = itm.targetType === 'table' ? this.state.tables?.map(x => `${x.schema}.${x.tableName}`)
            : null; //@@ ADD COMPONENTS LOOKUP

        let captionOfDetails = itm.targetType === 'table' ? 'جدول'
            : itm.targetType === 'webpage' || itm.targetType === 'urltable' || itm.targetType === 'ssc' ? 'URL'
                : itm.targetType === 'component' ? 'کمپوننت' : itm.targetType === 'script' ? 'اسکریپت' : '';

        let needsTargetProps = itm.targetType === 'component' || itm.targetType === 'urltable' || itm.targetType === 'table';
        let needsTextAreaForDetails = itm.targetType === 'script';

        return (
            <>
                {this.state.viewMode === 'design' ?
                    <Menu items={items} rtlEnabled showSubmenuMode='onHover'
                        key={'top' + this.state.itemsKey}
                    />
                    :
                    <WtMenu key={'wtmenu_' + this.state.name} name={this.state.name}
                        onComponentResult={co => this.setState({ testComponent: co })}
                    />
                }

                <div style={{ height: '2rem' }}>&nbsp;</div>

                {this.state.viewMode === 'preview'
                    ?
                    <div style={{ height: '80%', width: '80%', overflow: 'scroll' }}>
                        {this.state.testComponent ?? <h2 style={{ margin: '3rem', opacity: '30%' }}>کمپوننتی برای نمایش وجود ندارد</h2>}
                    </div>
                    :
                    <></>
                }

                <Inline spacing='1rem' style={{ marginTop: '50vh', width: '100%', justifyContent: 'center', position: 'fixed', bottom: '50px' }}
                >
                    <DropDownButton key={'btnViewMode_' + this.state.viewMode}
                        rtlEnabled width='15rem'
                        text={this.state.viewMode === 'preview' ? 'پیش نمایش' : 'طراحی'}
                        showArrowIcon icon={this.state.viewMode === 'preview' ? 'photo' : 'edit'}
                        selectedItemKey={this.state.viewMode}
                    >
                        <DdbItem text='طراحی' icon='edit' key='design' onClick={() => this.setViewMode('design')} />
                        <DdbItem text='پیش نمایش' icon='photo' key='preview' onClick={() => this.setViewMode('preview')} />
                    </DropDownButton>

                    <Button text='ساخت منوی جدید' icon='file' width='15rem' type='success' rtlEnabled
                        onClick={this.onBuildNewMenu} //stylingMode='outlined'
                    />
                    <Button text='بارگذاری' icon='folder' width='15rem' type='success' rtlEnabled
                        onClick={() => this.setState({ loadMenuPopVisible: true })}
                    />
                    <Button text='ذخیره' icon='save' width='15rem' type='success' rtlEnabled
                        onClick={() => this.setState({ saveMenuPopVisible: true })}
                    />
                </Inline>

                <Popup rtlEnabled title='آیتم منو' visible={this.state.itemPopVisible} onHiding={() => this.setState({ itemPopVisible: false })}
                    width='50rem' height='auto' //key={'itemPop_' + this.state._item.targetType}
                >
                    <Form colCount={60} key={`itemForm_${itm.targetType}`}
                    >
                        <SimpleItem colSpan={30}>
                            <Label text='متن' />
                            <TextBox value={itm.text}
                                onValueChanged={e => this.setState({ _item: { ...itm, text: e.value } })}
                            />
                        </SimpleItem>
                        <SimpleItem colSpan={30}>
                            <Label text='آیکون' />
                            <TextBox value={itm.icon} className='mdh-left-align'
                                onValueChanged={e => this.setState({ _item: { ...itm, icon: e.value } })}
                                buttons={[{
                                    name: 'loadIcon', options: {
                                        icon: 'more', onClick: () => window.notif('ERROR! NO CODE!')
                                    }
                                }]}
                            />
                        </SimpleItem>

                        <SimpleItem colSpan={30}>
                            <Label text='هدف' />
                            <SelectBox rtlEnabled valueExpr='value' displayExpr='text' value={itm.targetType}
                                onValueChanged={e => this.setState({ _item: { ...itm, targetType: e.value, targetDetails: '', targetProps: '' } })}
                            >
                                <SbItem text='زیرمنو' value='sub' />
                                <SbItem text='جدول' value='table' />
                                <SbItem text='جدول ریموت' value='urltable' />
                                <SbItem text='کمپوننت' value='component' />
                                <SbItem text='کمپوننت ریموت' value='ssc' />
                                <SbItem text='اسکریپت' value='script' />
                                <SbItem text='صفحه وب' value='webpage' />
                            </SelectBox>
                        </SimpleItem>

                        {captionOfDetails?.length > 0 ?
                            <SimpleItem colSpan={30}>
                                <Label text={captionOfDetails} />
                                {targetDetailsLookup?.length > 0
                                    ?
                                    <SelectBox rtlEnabled={false} className='mdh-left-align' dataSource={targetDetailsLookup}
                                        value={itm.targetDetails}
                                        onValueChanged={e => this.setState({ _item: { ...itm, targetDetails: e.value } })}
                                    />
                                    : needsTextAreaForDetails ?
                                        <TextArea rtlEnabled={false} className='mdh-left-align' value={itm.targetDetails} autoResizeEnabled
                                            onValueChanged={e => this.setState({ _item: { ...itm, targetDetails: e.value } })}
                                        />
                                        :
                                        <TextBox rtlEnabled={false} className='mdh-left-align' value={itm.targetDetails} //buttons={ }
                                            onValueChanged={e => this.setState({ _item: { ...itm, targetDetails: e.value } })}
                                        />
                                }
                            </SimpleItem>
                            :
                            <EmptyItem colSpan={30} />
                        }
                        {needsTargetProps &&
                            <SimpleItem colSpan={60}>
                                <Label text='مشخصات' />
                                <TextArea rtlEnabled={false} className='mdh-left-align' value={itm.targetProps} autoResizeEnabled
                                    onValueChanged={e => this.setState({ _item: { ...itm, targetProps: e.value } })}
                                />
                            </SimpleItem>
                        }
                    </Form>

                    <Inline spacing='1rem' style={{ marginTop: '2rem' }}>
                        <Button text='ثبت' icon='save' width='10rem' type='success'
                            onClick={() => {
                                if (itm.text?.length > 0)
                                    this.setState({ itemPopVisible: false }, () => this.onSaveItem(this.state.parentIid, true))
                            }}
                        />
                        <Button text='انصراف' icon='close' type='danger' width='10rem'
                            onClick={() => this.setState({ itemPopVisible: false })}
                        />
                    </Inline>
                </Popup>

                <Popup rtlEnabled title='ذخیره منو' visible={this.state.saveMenuPopVisible} onHiding={() => this.setState({ saveMenuPopVisible: false })}
                    width='20vw' height='auto'
                >
                    <Form colCount={60}>
                        <SimpleItem colSpan={60}>
                            <Label text='عنوان' />
                            <TextBox value={this.state.name}
                                onValueChanged={e => this.setState({ name: e.value })}
                            />
                        </SimpleItem>
                    </Form>
                    <br />
                    <Inline spacing='1rem'>
                        <Button text='ثبت' icon='save' width='10rem' type='success'
                            onClick={() => this.setState({ saveMenuPopVisible: false }, () => this.onSaveMenu())}
                        />
                        <Button text='انصراف' icon='close' type='danger' width='10rem'
                            onClick={() => this.setState({ saveMenuPopVisible: false })}
                        />
                    </Inline>
                </Popup>

                <Popup rtlEnabled title='بازیابی منو' visible={this.state.loadMenuPopVisible} onHiding={() => this.setState({ loadMenuPopVisible: false })}
                    width='20vw' height='auto' key={'loadPop' + this.state.namesKey}
                >
                    <Form colCount={60} key={'loadForm' + this.state.namesKey}>
                        <SimpleItem colSpan={50}>
                            <Label text='عنوان' />
                            <SelectBox items={this.state.names} value={this.state.name}
                                onValueChanged={e => this.setState({ name: e.value })}
                            />
                        </SimpleItem>
                        <ButtonItem colSpan={10}>
                            <ButtonOptions icon='refresh' onClick={() => this.onLoadMenusList()} />
                        </ButtonItem>
                    </Form>
                    <br />
                    <Inline spacing='1rem'>
                        <Button text='خواندن' icon='save' width='10rem' type='success'
                            onClick={() => this.setState({ loadMenuPopVisible: false }, () => this.onLoadMenu(this.state.name))}
                        />
                        <Button text='انصراف' icon='close' type='danger' width='10rem'
                            onClick={() => this.setState({ loadMenuPopVisible: false })}
                        />
                    </Inline>
                </Popup>
            </>
        );
    }
}

export default MenuBuilder;